import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Core2Config } from '../../shared';
import { WebsiteSettlementMethodLinkContainerModel } from '../../../../../../models';
import { BaseApiPublicLoginTemplateService } from '../../shared/base-api-public-login-template.service';

@Injectable({ providedIn: 'root' })

export class WebsiteSettlementMethodLinkService extends BaseApiPublicLoginTemplateService<WebsiteSettlementMethodLinkContainerModel, WebsiteSettlementMethodLinkContainerModel, WebsiteSettlementMethodLinkContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'website-settlement-method-links';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'website-settlement-method-links';
    this.endpoint_path_login_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.CMS_PREFIX + 'website-settlement-method-links/' + BaseApiPublicLoginTemplateService.LOGIN_EP;
    this.httpClient = http;
  }
}
